import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import AwardStatusCard from "./AwardStatusCard";
import AwardCategoryCard from "./AwardCategoryCard";
import RecentNominationSummary from "./RecentNominationSummary";
import RecentAwardeeSummary from "./RecentAwardeeSummary";
import { displayIcon } from "variables/icons";

const HyvidAwardsTab = () => {
  const [activeTab, setActiveTab] = useState("nominate");

  const tabOptions = [
    {
      label: "Nominate",
      value: "nominate",
      icon: displayIcon("Send"),
    },
    {
      label: "My Nominations",
      value: "nominations",
      icon: displayIcon("Sparkles"),
    },
    {
      label: "Award Winners",
      value: "award-winners",
      icon: displayIcon("Trophy"),
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <CustomTabs
        tabs={tabOptions}
        height="h-10"
        activeTab={activeTab}
        onChange={setActiveTab}
      />
       
      <div className="mt-3 space-y-4">
        {activeTab === "nominate" &&
        <div className="space-y-6">
          <AwardStatusCard/>
          <AwardCategoryCard/>
        </div>
        }
        {activeTab === "nominations" &&
        <div className="space-y-6 ">
          <RecentNominationSummary/>
        </div>
        }
        {activeTab === "award-winners" &&
        <div className="space-y-6">
          <RecentAwardeeSummary/>
        </div>
        }
        
        
      </div>
    </div>
  );
};

export default HyvidAwardsTab;
